import { render, staticRenderFns } from "./GetLoan.vue?vue&type=template&id=48b1f8ce&scoped=true"
import script from "./GetLoan.vue?vue&type=script&lang=js"
export * from "./GetLoan.vue?vue&type=script&lang=js"
import style0 from "./GetLoan.vue?vue&type=style&index=0&id=48b1f8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1f8ce",
  null
  
)

export default component.exports